import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import languageIcon from '../../assets/icons/language-icon-gray.svg';
import './SlidePanel.scss';

interface SlidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: 'left' | 'right';
}

export const SlidePanel: React.FC<SlidePanelProps> = ({
  isOpen,
  onClose,
  children,
  position = 'right',
}) => {
  const { i18n } = useTranslation();
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const panelVariants = {
    hidden: {
      x: position === 'right' ? '100%' : '-100%',
      boxShadow: position === 'right' ? 
        '-40px 0px 90px 0px rgba(0, 0, 0, 0)' : 
        '40px 0px 90px 0px rgba(0, 0, 0, 0)',
    },
    visible: {
      x: 0,
      boxShadow: position === 'right' ? 
        '-40px 0px 90px 0px rgba(0, 0, 0, 0.44)' : 
        '40px 0px 90px 0px rgba(0, 0, 0, 0.44)',
      transition: {
        type: 'spring',
        damping: 30,
        stiffness: 300,
      },
    },
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="slide-panel-overlay"
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={overlayVariants}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          onClick={onClose}
        >
          <motion.div
            className={`slide-panel ${position}`}
            variants={panelVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="panel-header">
              <button className="close-button" onClick={onClose}>
                CLOSE
              </button>
              <button
                className="language-toggle-slide-panel"
                onClick={() => {
                  const newLang = i18n.language === 'en' ? 'fr' : 'en';
                  i18n.changeLanguage(newLang);
                }}
              >
                <img src={languageIcon} alt="" />
                <span>{i18n.language.toUpperCase()}</span>
              </button>
            </div>
            <div className="slide-panel-content">
              {children}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
